var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        class: _vm.customClass,
        on: {
          click: function($event) {
            _vm.handleClickLike()
          }
        }
      },
      [
        _c("transition", { attrs: { name: "like-icon", mode: "out-in" } }, [
          _c("i", {
            key: _vm.item.liked,
            class: _vm.item.liked
              ? "fa fa-thumbs-up liked-icon"
              : "fa fa-thumbs-o-up",
            attrs: { "aria-hidden": "true" }
          })
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "like-bounce", mode: "out-in" } }, [
          _c("span", { key: _vm.item.likes, staticClass: "like-number" }, [
            _vm._v("\n        " + _vm._s(_vm.item.likes) + "\n      ")
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ed2bf3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ed2bf3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/components/LikeButton.vue
// module id = null
// module chunks = 